// Fichiers joints au composeur, pas encore envoyes (liste repliable, maquette
// « Messagerie · bureau », proposition D).
export type ComposerAttachmentStatusType = 'uploading' | 'ready' | 'error'

export type ComposerAttachmentType = {
  id: string
  name: string
  ext?: string
  size?: number | null
  status: ComposerAttachmentStatusType
  // avancement de l'envoi, 0 a 100
  percentage?: number
}

export type ComposerAttachmentsSummaryType = {
  total: number
  uploading: number
  failed: number
}

// au-dela de ce nombre, la liste se replie d'elle-meme : le resume suffit
export const COMPOSER_ATTACHMENTS_COLLAPSE_AFTER = 5

export function getComposerAttachmentsSummary(items: ComposerAttachmentType[]): ComposerAttachmentsSummaryType {
  return {
    total: items.length,
    uploading: items.filter((item) => item.status === 'uploading').length,
    failed: items.filter((item) => item.status === 'error').length,
  }
}
